module.exports = __webpack_public_path__ + "media/flags/by-aff3158e.svg";